import { useSelector } from 'react-redux'
import { Table } from '../../../../../common/table'
import {
  changeBalanceSheetIds,
  selectBalanceSheetChildIds,
  selectBalanceSheetIds,
  selectBalanceSheetItem,
  selectBalanceSheetParentId,
  selectBalanceSheetRowData,
  selectIsLoading,
  selectTableHeader,
} from '../store/slice'
import { CustomTHead } from '../table/CustomTHead'
import { FinancialStatementsValueCell } from '../table/FinancialStatementsValueCell'
import { FirstColumnCell } from '../table/firstColumnCell/FirstColumnCell'

export const BalanceSheet = () => {
  const balanceSheetIds = useSelector(selectBalanceSheetIds)
  const isLoading = useSelector(selectIsLoading)
  const tableHeader = useSelector(selectTableHeader)

  return (
    <Table
      ids={balanceSheetIds}
      getDataFromRedux={selectBalanceSheetItem}
      isLoading={isLoading}
      isNoDataWithHead={true}
      autoHeightMax={400}
      renderTHead={() => <CustomTHead tableTitle={tableHeader} />}
      schema={tableHeader.map((item, index) => {
        if (index === 0) {
          return {
            ...item,
            render: (val, { rowId }) => {
              return (
                <FirstColumnCell
                  ids={balanceSheetIds}
                  rowId={rowId}
                  val={val}
                  selectRowData={selectBalanceSheetRowData}
                  selectChildIds={selectBalanceSheetChildIds}
                  selectParentIds={selectBalanceSheetParentId}
                  changeIds={changeBalanceSheetIds}
                  tabName="balanceSheets"
                  style={{ minWidth: 420 }}
                />
              )
            },
          }
        }

        return {
          ...item,
          render: (val) => {
            return <FinancialStatementsValueCell val={val} />
          },
        }
      })}
    />
  )
}
